function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgResumed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 187",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07 15.657 13.295 13 9.07 10.343zm-4.1 2.405a.951.951 0 0 1-.683-.283.891.891 0 0 1-.287-.66V8.943a.891.891 0 0 1 .293-.66A.951.951 0 0 1 4.975 8h11.05a.951.951 0 0 1 .683.283.891.891 0 0 1 .293.66v8.175a.891.891 0 0 1-.293.66.951.951 0 0 1-.683.283zm0-.943h11.05V8.943H4.975zm0 0z",
    transform: "translate(-2.5 -5.032)",
    style: {
      fill: "#3953fb"
    }
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResumed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resumed.0c65c9e0.svg";
export { ForwardRef as ReactComponent };